/* here&found — <hf-sticky-buy> (assets/hf-sticky-buy.js).
   The mobile PDP buy-bar. Watches the in-page buy panel with an
   IntersectionObserver; once the panel has scrolled up out of the viewport,
   the bar slides in from the bottom on --ease-glide (the transition rides the
   theme's --dur-slow token, which collapses to .01ms under
   prefers-reduced-motion — no separate guard needed for the slide).

   Contract with the PDP section (pass 3):
   - the bar markup is <hf-sticky-buy hidden> … </hf-sticky-buy>; it stays
     `hidden` with JS off, so it can never cover content on the no-JS page;
   - the observed panel is `target` (a selector attribute) or, by default,
     [data-hf-buy-panel];
   - desktop keeps the sticky buy PANEL, so the bar only arms below 1000px.
   Observers/listeners are torn down on disconnect. */

class HFStickyBuy extends HTMLElement {
  connectedCallback() {
    this.panel = document.querySelector(this.getAttribute('target') || '[data-hf-buy-panel]');
    if (!this.panel) return;

    this.style.position = 'fixed';
    this.style.left = '0';
    this.style.right = '0';
    this.style.bottom = '0';
    this.style.zIndex = '30';
    this.style.transform = 'translateY(110%)';
    this.style.transition = 'transform var(--dur-slow) var(--ease-glide)';

    this.mql = window.matchMedia('(min-width: 1000px)');
    this.onMedia = () => this.arm();
    this.mql.addEventListener('change', this.onMedia);

    this.io = new IntersectionObserver((entries) => {
      const entry = entries[0];
      // show only once the panel has been scrolled PAST (it sits above the fold)
      this.passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.render();
    });

    this.arm();
  }

  disconnectedCallback() {
    if (this.io) this.io.disconnect();
    if (this.mql) this.mql.removeEventListener('change', this.onMedia);
  }

  arm() {
    if (this.mql.matches) {
      // desktop: the sticky buy panel owns this job
      this.io.unobserve(this.panel);
      this.passed = false;
      this.render();
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
      this.io.observe(this.panel);
    }
  }

  render() {
    this.style.transform = this.passed ? 'translateY(0)' : 'translateY(110%)';
    this.setAttribute('aria-hidden', this.passed ? 'false' : 'true');
    this.toggleAttribute('inert', !this.passed);
  }
}

if (!customElements.get('hf-sticky-buy')) customElements.define('hf-sticky-buy', HFStickyBuy);
